import { HomeItem } from "../../../../models/home-rows";
import DesktopSlider from "./desktopSlider";
import style from "./fixedSlider.module.scss";
import { MobileSlider } from "./mobileSlider";

type CharacterSwiperProps = {
  homeItem: HomeItem;
  showFixSlider?: boolean;
  showSpecialRow?: boolean;
};
const FixedSlider = ({
  homeItem,
  showFixSlider,
  showSpecialRow
}: CharacterSwiperProps) => {
  return (
    <>
      {showSpecialRow && (
        <div className={`${style.sliderWrapper}`}>
          {homeItem?.products &&
            homeItem?.products.length > 0 &&
            !showFixSlider && <DesktopSlider products={homeItem?.products} />}
        </div>
      )}
      {/* <div className={`${style.sliderMobileWrapper}`}>
        {homeItem?.products && homeItem?.products.length > 0 && (
          <MobileSlider products={homeItem?.products} />
        )}
      </div> */}
      {showFixSlider && (
        <div className={`${style.sliderMobileWrapper}`}>
          {homeItem?.products && homeItem?.products.length > 0 && (
            <MobileSlider products={homeItem?.products} intervalTime={6000} />
          )}
        </div>
      )}
    </>
  );
};

export default FixedSlider;
